<template>
    <div class="file-list-wrap">
        <div class="file-table">
            <el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle" :height="PAGESIZE.h-340" >
                <el-table-column prop="fileType" label="附件类型" :show-overflow-tooltip="true" >
                     <template slot-scope="scope">
                         <span v-if="scope.row.fileType == 1">供应商上传</span>
                         <span v-else>采购方下发</span>
                     </template>
                </el-table-column>
                <el-table-column prop="supplierInfoName" label="上传的供应商" :show-overflow-tooltip="true" > </el-table-column>
                <el-table-column prop="fileName" label="附件名" :show-overflow-tooltip="true" > </el-table-column>
                <el-table-column label="附件" width="95">
                    <template slot-scope="scope">
                        <el-link v-if="(scope.row.fileType == 1 && scope.row.isDown)|| scope.row.fileType != 1 || userInfo.id == scope.row.createUser" :underline="false" :href="baseURL+scope.row.fileUrl" target="_blank">
                            <el-tag type="success">查看附件</el-tag>
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="操作" v-if="checkRole('cgy_role')">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" :disabled="scope.row.fileType == 1" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" :disabled="scope.row.fileType == 1" @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="操作" v-if="checkRole('gys_role') && orderInfo.gysOrderState==3">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" v-if="userInfo.id == scope.row.createUser" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" v-if="userInfo.id == scope.row.createUser" @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :visible.sync="openDialog" width="800px" :title="title" :close-on-click-modal="false">
            <el-form label-width="110px" ref="form" :model="form" :rules="rules" size="small">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="附件名" prop="fileName">
                            <el-input v-model="form.fileName" placeholder="请输入附件名" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="附件" prop="fileUrl">
                            <el-upload class="upload-demo" :action="upload()" :show-file-list="false"
                                accept=".xls,.xlsx,.doc,.docx,.pdf,application/msword" :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload" :headers="{'Authentication':token()}">
                                <el-input style="width:100%" v-model="form.fileUrl" placeholder="点击文本框上传" readonly slot="trigger" />
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="openDialog = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { queryInquiryAttachListByOrderId,inquiryAttachAdd,inquiryAttachEdit,inquiryAttachDel } from '@/api/srm/inquiryDetail.js';
export default {
    props:['orderInfo'],
    data(){
        return {
            tableData:[],
            openDialog:false,
            title:'',
            form:{
                id:'',
                orderId:this.$route.query.hId,
                fileName:'',
                fileUrl:'',
            },
            rules:{
                 fileName: [{ required: true, message: '请输入附件名称',  trigger: 'blur' }],
                 fileUrl: [{ required: true, message: '请上传附件',  trigger: 'blur' }],
            }
        }
    },
    mounted(){
        console.log(this.userInfo)
        this.getFileList();
    },
    methods:{
        async getFileList() {
            let _this = this;
            const {
                data: res
            } = await queryInquiryAttachListByOrderId({orderId:_this.$route.query.hId})
            if (res.code == 0) {
                _this.tableData = res.data || [];
            }
        },
        // 表单重置
        reset: function() {
            this.form = {
                id:undefined,
                orderId:this.$route.query.hId,
                fileName:undefined,
                fileUrl:undefined,
            }
            if (this.$refs["form"] !== undefined) {
                this.$refs["form"].resetFields();
            }
        },
        // 新增
        addFile(){
            this.reset();
            this.title = '新增'
            this.openDialog = true;
        },
        // 编辑
        handleEdit:function(row){
            this.reset();
            this.form.id=row.id;
            this.form.fileName=row.fileName;
            this.form.fileUrl=row.fileUrl;
            this.title = '编辑'
            this.openDialog = true;
        },
        // 删除
        handleDel:function(row){
            let _this = this;
            _this.confirm({
                text: '确认删除吗',
                tip: '警告',
                type: '',
                fn: function(param) {
                    inquiryAttachDel(param).then(response => {
                        if (response.data.code === 0) {
                            _this.$success(response.data.msg);
                            _this.getFileList();
                        } else {
                            _this.$fail(response.data.msg);
                        }
                    });
                },
                data: {
                    id: row.id
                } //参数对象 主要回调函数用
            });
        },
        // 提交
        submitForm(){
            let _this = this;
            _this.$refs['form'].validate((valid) => {
                if (valid) {
                    let curForm = {..._this.form};
                    if (_this.form.id ){    // 编辑
                        inquiryAttachEdit(curForm).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                _this.getFileList();
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    }else{  // 新增
                        delete curForm.id
                        inquiryAttachAdd(curForm).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                _this.getFileList();
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    }
                }
            })
        },
        handleAvatarSuccess(res, file) {
            if (res.code == 0) {
                this.$success(res.msg);
                if (this.form.fileUrl != "" && this.form.fileUrl != undefined) {
                    //如果修改附件 则删除原来的附件
                    if (this.form.fileUrl != res.data.url) {
                        this.delFile(this.form.fileUrl);
                    }
                }
                this.form.fileUrl = res.data.url;
            }
        },
        beforeAvatarUpload(file) {
            let sizeNum = 50;
            const size = file.size / 1024 / 1024 < sizeNum;
            if (!size) {
                this.$fail(`上传附件大小不能超过 ${sizeNum}MB!`);
            }
            return size;
        },
    },
    computed:{
        userInfo:function(){
            return this.$store.getters['user/user'];
        },
        PAGESIZE:function(){
            return this.$store.getters['app/sizeInfo'];
            // 询价单新增附件接口，入参是：
            // {
            //     orderId:1,  // 询价单主键id
            //     fileName:'',    // 附件名称
            //     fileUrl:'', // 上传后的附件地址
            // }
            // 一个订单可以新增多次附件，这里所以还需要一个
            // 编辑接口，可以修改附件名称
            // 删除接口，删除附件
            // 一共三个接口
        },
    },
}
</script>
<style lang="sass" scoped>

</style>
